import Link from "next/link";

import { imageUrlFor } from "lib/remoteContent";

import UserAvatar from "./UserAvatar";
import styles from "./StoryCard.module.css";

import type { CommunityStory } from "lib/remoteContent";

const StoryCard = ({ story }: { story: CommunityStory }) => (
  <Link href={`/community-stories/${story.slug.current}`}>
    <a className={styles.story}>
      <UserAvatar avatar={imageUrlFor(story.avatar).width(160).url()} alt={story.name} size="small" />
      <div className={styles.details}>
        <div className={styles.readMore}>Read more</div>
        <div className={styles.name}>{story.name}</div>
        <div className={styles.position}>{story.position}</div>
      </div>
    </a>
  </Link>
);

export default StoryCard;
